import { render } from "./PageListDataUser.vue?vue&type=template&id=3f5dfb1f"
import script from "./PageListDataUser.vue?vue&type=script&lang=js"
export * from "./PageListDataUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__